// @ts-nocheck



import React from 'react';
import { Option, Select } from './../ant/Select';






const AutoGeneratedEnumSelect = ({
  autoType,
  ...selectProps
}) =>
<Select
  allowClear
  {...selectProps}
  value={selectProps.value || selectProps.defaultValue}>

    {Object.keys(autoType).map((key) =>
  <Option key={key} value={key}>
        {autoType[key]}
      </Option>
  )}
  </Select>;


const AutoGeneratedMultipleEnumSelectT = ({
  autoType,
  ...selectProps
}) => {
  return (
    <Select allowClear {...selectProps} mode="multiple" optionLabelProp="label">
      {Object.keys(autoType).map((key) =>
      <Option key={key} value={key} label={autoType[key]}>
          {autoType[key]}
        </Option>
      )}
    </Select>);

};

// Обертка для создания списков из объекта
export const AutoGeneratedMultipleEnumSelect = (props) => {
  return function (otherProps) {
    return AutoGeneratedMultipleEnumSelectT({ ...props, ...otherProps });
  };
};

// Обертка для создания списков из объекта
export default (props) => {
  return function (otherProps) {
    return AutoGeneratedEnumSelect({ ...props, ...otherProps });
  };
};
